export default function Footer() {
  return (
    <div className="relative block w-full py-[30px] bg-[#252525]">
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <p className="text-[14px] text-white text-center">© Copyright 2024 — Glocify Technologies – All Rights Reserved</p>
      </div>
    </div>
  )
};
